import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import { APP_URL } from '../../../config';

function* billingSubscriptionPortal({ payload: { onSuccess, handledErrors } = {} }) {
  try {
    const { data } = yield call(fetch, {
      api: api.stripeBilling,
      data: {
        return_url: `${APP_URL}billing?tab=subscriptions`
      }
    });

    onSuccess && onSuccess(data.result);
    yield put(actions.billingSubscriptionPortalDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.billingSubscriptionPortalFailed,
      handledErrors,
      endpoint: api.stripeBilling.url
    });
  }
}

export const billingSubscriptionPortalSaga = takeEvery(types.BILLING_SUBSCRIPTION_PORTAL_REQUEST, billingSubscriptionPortal);